import client from '@/services/http/client'
import { isMockEnabled, mockDelay } from '@/services/http/mock'
import type { WorkflowTraceDetail } from '@/types/workflowTrace'

const mockWorkflowTrace: WorkflowTraceDetail = {
  entry: {
    entry_type: 'sla-event',
    entry_id: 'sla-001',
  },
  summary: {
    current_stage: 'ticket_waiting_start',
    bottleneck_stage: 'ticket',
    bottleneck_reason_code: 'waiting_start_timeout',
    bottleneck_reason_text: '工单已创建但仍未接单，流程阻塞在工单处理阶段。',
    highest_alarm_level: 'L1 一级提醒',
    active_alert_count: 1,
    pending_owner: 'tech_a',
  },
  entities: {
    message: {
      entity_type: 'message',
      visible: true,
      message_id: 'msg-001',
      room_id: 'room-001',
      room_name: '默认测试群',
      message_status: 'pending_response',
      send_time: '2026-05-14T14:00:00+08:00',
      content_preview: '报到机查询排班提示未在班。',
    },
    draft: {
      entity_type: 'draft',
      visible: true,
      id: 'draft-001',
      draft_no: 'GD-20260514-0001',
      status: 'confirmed',
      room_id: 'room-001',
      task_title: '排查-报到机-排班异常',
    },
    ticket: {
      entity_type: 'ticket',
      visible: true,
      mapping_id: 'map-001',
      zentao_task_id: 1001,
      platform_status: 'waiting_start',
      task_title: '排查-报到机-排班异常',
    },
  },
  stages: [
    { stage_code: 'message_intake', stage_name: '消息受理', status: 'completed' },
    { stage_code: 'draft_review', stage_name: '草稿确认', status: 'completed' },
    { stage_code: 'ticket_processing', stage_name: '工单处理', status: 'current' },
    { stage_code: 'customer_confirm', stage_name: '客户确认', status: 'pending' },
  ],
  alerts: [
    {
      rule_code: 'waiting_start_timeout',
      rule_name: '待接单超时',
      event_status: 'open',
      current_escalation_level: 1,
      first_detected_at: '2026-05-14T14:30:00+08:00',
      target_account: 'tech_a',
    },
  ],
  timeline: [
    {
      occurred_at: '2026-05-14T14:00:00+08:00',
      stage_code: 'message_intake',
      event_type: 'message_received',
      title: '收到客户消息',
    },
    {
      occurred_at: '2026-05-14T14:30:00+08:00',
      stage_code: 'ticket_waiting_start',
      event_type: 'sla_alert_triggered',
      title: '工单已创建但仍未接单，流程阻塞在工单处理阶段。',
    },
  ],
  actions: {
    message: { message_id: 'msg-001' },
    draft: { draft_id: 'draft-001' },
    ticket: { mapping_id: 'map-001' },
    workflow_trace: { entry_type: 'sla-event', entry_id: 'sla-001' },
  },
}

export async function fetchWorkflowTrace(entryType: string, entryId: string): Promise<WorkflowTraceDetail> {
  if (isMockEnabled()) {
    await mockDelay()
    return {
      ...mockWorkflowTrace,
      entry: {
        entry_type: entryType,
        entry_id: entryId,
      },
      actions: {
        ...mockWorkflowTrace.actions,
        workflow_trace: { entry_type: entryType, entry_id: entryId },
      },
    }
  }

  const { data } = await client.get<WorkflowTraceDetail>(
    `/workflow-traces/${encodeURIComponent(entryType)}/${encodeURIComponent(entryId)}`,
  )
  return data
}